import { Component, effect, inject, Input, signal } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CustomBreadcrumbService } from '../../../services/custom-breadcrumb/custom-breadcrumb.service';
import { ICustomMenuItem } from '../../../models/ICustomMenuItem';

@Component({
  selector: 'app-custom-breadcrumb',
  imports: [BreadcrumbModule, FaIconComponent, CommonModule, RouterModule],
  templateUrl: './custom-breadcrumb.component.html',
  styleUrl: './custom-breadcrumb.component.scss'
})
export class CustomBreadcrumbComponent{
  faChevronRight = faChevronRight;
  readonly customBreadcrumbService = inject(CustomBreadcrumbService);

  @Input() separatorIsChevron:boolean = false;
  @Input() separatorCharacter:string = "/";
  @Input() isSmall:boolean = false;
  @Input() isColorLight:boolean = false;
  @Input() isFontMulish:boolean = false;
  @Input() hideOnMobile:boolean = false;
  @Input() resultsText:boolean = false;

  items = signal<ICustomMenuItem[] | undefined>(undefined);

  constructor(){
    effect(() => {
      this.items.update(items => this.customBreadcrumbService.items());
    });
  }

}
